/* Cursorul Înainte / După. Mouse, deget (fără să blocheze derularea pe verticală)
   și tastatură (săgeți, prin <input type="range"> ascuns). */
(function () {
  'use strict';

  function init(el) {
    if (el.hasAttribute('data-rf-bound')) return;
    el.setAttribute('data-rf-bound', '');

    var range = el.querySelector('.rf-compare__range');
    var dragging = false, rect = null, frame = 0, pending = null, touched = false;

    function set(pos) {
      pos = Math.max(0, Math.min(100, pos));
      el.style.setProperty('--rf-pos', pos + '%');
      if (range) range.value = Math.round(pos);
      if (pos < 12) el.setAttribute('data-edge', 'start');
      else if (pos > 88) el.setAttribute('data-edge', 'end');
      else el.removeAttribute('data-edge');
    }

    function fromEvent(e) {
      return ((e.clientX - rect.left) / rect.width) * 100;
    }

    function schedule(pos) {
      pending = pos;
      if (frame) return;
      frame = requestAnimationFrame(function () { frame = 0; set(pending); });
    }

    el.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      dragging = true; touched = true;
      rect = el.getBoundingClientRect();
      el.classList.add('is-dragging');
      el.classList.remove('is-hinting');
      try { el.setPointerCapture(e.pointerId); } catch (err) {}
      schedule(fromEvent(e));
    });
    el.addEventListener('pointermove', function (e) {
      if (dragging) schedule(fromEvent(e));
    });
    function stop() { dragging = false; el.classList.remove('is-dragging'); }
    el.addEventListener('pointerup', stop);
    el.addEventListener('pointercancel', stop);
    el.addEventListener('lostpointercapture', stop);

    if (range) {
      range.addEventListener('input', function () { touched = true; set(parseFloat(range.value)); });
      // clicul pe imagine trebuie să ajungă la container, dar tastatura la <input>
      el.addEventListener('click', function () { range.focus({ preventScroll: true }); });
    }

    // indiciu: la prima apariție pe ecran, cursorul se plimbă o dată singur
    if ('IntersectionObserver' in window && !RF.reducedMotion && !el.hasAttribute('data-no-hint')) {
      var start = parseFloat(getComputedStyle(el).getPropertyValue('--rf-pos')) || 50;
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0].isIntersecting) return;
        io.disconnect();
        setTimeout(function () {
          if (touched) return;
          el.classList.add('is-hinting');
          set(Math.max(18, start - 26));
          setTimeout(function () { if (!touched) set(Math.min(82, start + 22)); }, 950);
          setTimeout(function () { if (!touched) set(start); }, 1900);
          setTimeout(function () { el.classList.remove('is-hinting'); }, 2900);
        }, 500);
      }, { threshold: 0.6 });
      io.observe(el);
    }
  }

  RF.compare = { init: init };
  RF.register(function (root) { root.querySelectorAll('[data-rf-compare]').forEach(init); });
})();
